{
  "name": "sonda",
  "homepage": ".",
  "version": "1.24.9",
  "private": true,
  "companyName": "Reyedar B.V.",
  "type": "module",
  "packageManager": "yarn@1.22.22",
  "engines": {
    "node": "^22.22.2",
    "yarn": ">=1.22.0"
  },
  "dependencies": {
    "@aws-sdk/client-cognito-identity": "^3.1145.0",
    "@aws-sdk/client-s3": "^3.1145.0",
    "@aws-sdk/credential-provider-cognito-identity": "^3.972.71",
    "@aws-sdk/credential-providers": "^3.1145.0",
    "@aws-sdk/s3-request-presigner": "^3.1145.0",
    "@emotion/react": "^11.14.0",
    "@emotion/styled": "^11.14.1",
    "@mui/icons-material": "^9.5.0",
    "@mui/material": "^9.5.0",
    "@mui/system": "^9.5.0",
    "@mui/x-date-pickers": "^9.16.0",
    "amazon-cognito-identity-js": "^6.3.20",
    "axios": "^1.20.0",
    "bootstrap": "^5.3.8",
    "d3": "^7.9.0",
    "date-fns": "^4.4.0",
    "formik": "^2.4.9",
    "moment": "^2.31.0",
    "react": "^19.3.0",
    "react-dom": "^19.3.0",
    "react-icons": "^5.7.0",
    "react-router-dom": "^7.18.4",
    "yup": "^1.7.1"
  },
  "scripts": {
    "preinstall": "node -e \"const [M,m,p]=process.versions.node.split('.').map(Number); const ok=M===22&&(m>22||(m===22&&p>=2)); if(!ok){console.error('\\u274c Unsupported Node version:',process.versions.node,'\\nRequired: ^22.22.2 (Node 22.22.2 or newer, Node 22 only)'); process.exit(1)}\"",
    "clean": "rm -rf node_modules",
    "start": "yarn lint && vite",
    "build": "vite build",
    "test": "vitest",
    "lint": "eslint src/",
    "format": "prettier --write .",
    "format:check": "prettier --check .",
    "lint:fix": "eslint src/ --fix"
  },
  "browserslist": {
    "production": [
      ">0.2%",
      "not dead",
      "not op_mini all"
    ],
    "development": [
      "last 1 chrome version",
      "last 1 firefox version",
      "last 1 safari version"
    ]
  },
  "devDependencies": {
    "@testing-library/dom": "^10.4.2",
    "@testing-library/jest-dom": "^7.0.1",
    "@testing-library/react": "^16.3.3",
    "@testing-library/user-event": "^14.6.7",
    "@vitejs/plugin-react": "^6.1.2",
    "eslint": "9.39.5",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-jsx-a11y": "^6.10.2",
    "eslint-plugin-no-secrets": "^2.3.3",
    "eslint-plugin-prettier": "^5.5.6",
    "eslint-plugin-react": "^7.37.5",
    "eslint-plugin-react-hooks": "^7.1.1",
    "eslint-plugin-security": "^4.2.0",
    "jsdom": "^30.1.2",
    "prettier": "^3.9.9",
    "vite": "8.3.4",
    "vitest": "5.0.3"
  }
}